import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

/**
 * Global sticky banner shown on every Customer page while
 * ``profile_verified_at IS NULL``. Not dismissible; disappears the moment the
 * Customer confirms their master data via /customer/account.
 *
 * v34.29 — pilot UX hardening: banner + first-login prompt were previously
 * hero-only on /customer; the pilot showed customers were missing the CTA
 * because they navigated straight to the catalog. This component lives in
 * ShellLayout and is visible on every route the Customer visits.
 */
export default function ProfileVerificationBanner() {
  const { user, apiGet } = useAuth();
  const location = useLocation();
  const [required, setRequired] = useState(false);
  const isCustomer = (user?.roles || []).includes("CUSTOMER");

  useEffect(() => {
    if (!isCustomer) { setRequired(false); return; }
    let alive = true;
    apiGet("/api/customer/account/profile")
      .then((p) => { if (alive) setRequired(!!p?.profile_verification_required); })
      .catch(() => { if (alive) setRequired(false); });
    return () => { alive = false; };
    // Refresh whenever the route changes (cheap; endpoint is fast).
  }, [isCustomer, location.pathname, apiGet]);

  if (!isCustomer || !required) return null;

  const onAccount = location.pathname.startsWith("/customer/account");

  return (
    <div
      data-testid="global-profile-verification-banner"
      style={{
        position: "sticky", top: 0, zIndex: 40,
        background: "#B45309", color: "#fff",
        padding: "10px 16px", borderBottom: "2px solid #92400E",
        display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12,
        boxShadow: "0 2px 4px rgba(0,0,0,.15)",
      }}
    >
      <div style={{ flex: 1, minWidth: 240 }}>
        <div style={{ fontWeight: 800, fontSize: "1rem" }}>
          Conferma i tuoi dati aziendali
        </div>
        <div style={{ fontSize: ".92rem", opacity: .95 }}>
          Prima di poter inviare un ordine devi controllare e confermare i dati della tua azienda.
        </div>
      </div>
      {!onAccount && (
        <Link
          to="/customer/account"
          data-testid="global-profile-verification-cta"
          style={{
            background: "#fff", color: "#7C2D12",
            padding: "10px 18px", borderRadius: 8,
            fontWeight: 800, textDecoration: "none",
            border: "2px solid #fff", whiteSpace: "nowrap",
          }}
        >
          CONTROLLA E CONFERMA I DATI
        </Link>
      )}
    </div>
  );
}
